import React, { useState, useEffect } from 'react';
import { Form, Modal } from 'react-bootstrap';
import { DataTable, Filter, Input, MultiSelect, PageWrapper } from '../../components';
import { Dropdown } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useForm, FormProvider } from "react-hook-form";
import 'react-checkbox-tree/lib/react-checkbox-tree.css';
import { Role } from '../../shared/enums';
import { createPushNotification, getPushNotificationList } from '../../api/push-notification';
import dayjs from 'dayjs';
import { DATETIME_FORMAT, DATETIME_WITHOUT_SECOND_FORMAT } from '../../shared/constants';
import { RiAddLargeLine } from 'react-icons/ri';
import Button from '../../components/common/Button';

const Broadcast = () => {
    const { t } = useTranslation()
    const DEFUALT_OPTIONS = [
        { label: t(Role.USER.toUpperCase()), value: Role.USER },
        { label: t(Role.DRIVER.toUpperCase()), value: Role.DRIVER }
    ]
    const form = useForm()
    const [filter, setFilter] = useState({});
    const [pagination, setPagination] = useState({ page: 1, pageSize: 25 });
    const [totalPages, setTotalPage] = useState(0);
    const [data, setData] = useState([]);
    const [selected, setSelected] = useState(null);
    const [isSendAgain, setIsSendAgain] = useState(false);
    const [options, setOptions] = useState(DEFUALT_OPTIONS)

    const columns = [
        {
            key: "groups",
            label: t("GROUPS"),
            render: (groups, data) => groups.map(e => t(e.toUpperCase())).join(", "),
        },
        { key: "title", label: t("TITLE"), },
        { key: "body", label: t("BODY"), },
        { key: "createdAt", label: t("SENT_AT"), render: (createdAt, data) => dayjs(createdAt).format(DATETIME_FORMAT) },
        { key: "executeAt", label: t("SCHEDULE_SEND_AT"), render: (executeAt, data) => executeAt ? dayjs(executeAt).format(DATETIME_FORMAT) : "-" },
        {
            key: "action",
            label: t("ACTION"),
            render: (v, data) => <Dropdown>
                <Dropdown.Toggle variant="primary" size="sm" className='py-0'></Dropdown.Toggle>
                <Dropdown.Menu>
                    <Dropdown.Item onClick={() => sendAgain(data)}>{t("SEND_AGAIN")}</Dropdown.Item>
                </Dropdown.Menu>
            </Dropdown>
        }
    ]

    const filters = [
        { type: "input", label: t("SEARCH"), name: "search" }
    ]

    useEffect(() => {
        getData(pagination, filter)
    }, [pagination, filter])

    const getData = async (pagination, filter) => {
        const response = await getPushNotificationList({ skip: (pagination?.page - 1) * pagination?.pageSize, limit: pagination?.pageSize, ...filter })
        setData(response.items)
        setTotalPage(Math.ceil(response?.pagination?.total / pagination?.pageSize))
    }

    const sendAgain = (selected) => {
        setIsSendAgain(true);
        form.reset({ ...selected, groups: DEFUALT_OPTIONS.filter(e => selected.groups.includes(e.value)), executeAt: dayjs(selected.executeAt).format(DATETIME_WITHOUT_SECOND_FORMAT) })
        setSelected(selected)
        setOptions(DEFUALT_OPTIONS.filter(e => !selected.groups.includes(e.value)))
    }

    const onAddClick = () => {
        setIsSendAgain(false);
        form.reset({ title: "" })
        setSelected({})
        setOptions(DEFUALT_OPTIONS)
    }

    const send = async (data) => {
        const response = await createPushNotification({ title: data.title, body: data.body, groups: data.groups.map(e => e.value), executeAt: data?.executeAt })
        if (response.success) {
            setSelected(null)
            getData(pagination, filter)
        }
    }

    return (
        <PageWrapper
            headerProps={{
                title: "BROADCAST",
                rightElement: <Button icon={<RiAddLargeLine />} onClick={onAddClick}>{t("NEW")}</Button>
            }}
        >
            <Filter filters={filters} onChangeFilter={setFilter} />
            <DataTable columns={columns} data={data} pagination={{ ...pagination, totalPages, onChange: setPagination }} />

            <Modal show={selected} onHide={() => setSelected(null)}>
                <FormProvider {...form}>
                    <Form onSubmit={form.handleSubmit(send)}>
                        <Modal.Header closeButton>
                            <Modal.Title>{t(isSendAgain ? "SEND_AGAIN" : "SEND_NOTIFICATION")}</Modal.Title>
                        </Modal.Header>
                        <Modal.Body style={{ height: "76vh", overflow: "auto" }}>
                            <Input label={t("TITLE")} name={"title"} rules={{ required: t("TITLE_IS_REQUIRED") }} />
                            <Input label={t("BODY")} name={"body"} rules={{ required: t("BODY_IS_REQUIRED") }} rows={3} />
                            <MultiSelect
                                label={t("GROUPS")}
                                name={"groups"}
                                options={options}
                            />
                            <Input label={t("SEND_AT")} name={"executeAt"} type="datetime-local" rules={{
                                validate: (value) => {
                                    if (!value) return true
                                    const selectedDate = new Date(value);
                                    const now = new Date();
                                    if (selectedDate < now) {
                                        return t("DATE_TIME_PAST_ERROR");
                                    }
                                    return true;
                                }
                            }} />
                        </Modal.Body>
                        <Modal.Footer>
                            <Button variant="secondary" onClick={() => setSelected(null)}>
                                {t("CLOSE")}
                            </Button>
                            <Button variant="primary" type='submit'>
                                {t("SEND")}
                            </Button>
                        </Modal.Footer>
                    </Form>
                </FormProvider>
            </Modal>
        </PageWrapper>
    );
};

export default Broadcast;
